import { Widget, Paginator } from '@/types'
import { requests, responseBody } from '../http/axios'
import { removeNullParams, snakeCaseObject } from '@/helper/formatter'

export type WidgetFilters = {
  limit?: number
  page?: number
  storeId?: string
  q?: string
}

export const WidgetService = {
  getWidgets: async (params: WidgetFilters): Promise<Paginator<Widget>> =>
    await requests.get(`widgets?` + removeNullParams(params).toString()),

  getWidget: async (
    uuid: string,
    params: { isEditMode?: boolean } = {}
  ): Promise<Widget> =>
    await requests
      .get(`widgets/${uuid}?` + removeNullParams(params).toString())
      .then(responseBody),

  updateWidget: async (widget: Widget): Promise<Widget> =>
    await requests.put(`widgets/${widget.uuid}`, snakeCaseObject(widget)),

  createWidget: async (widget: Widget): Promise<Widget> =>
    await requests.post(`widgets`, snakeCaseObject(widget)),

  updateWidgetFallbackLocale: async (
    uuid: string,
    locale: string
  ): Promise<Widget> =>
    await requests.put(`widgets/${uuid}/fallback-locale`, { locale }),
}
